import React, { useCallback, useEffect } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import PopupMask from "@/componentsUI/PopupMask";
import {
  LOGIN_REMINDER_DISMISSED_EVENT,
  markLoginReminderDismissedForCurrentHomeEntry,
} from "@/features/modalOrchestrator/loginReminder";
import { useGlobalState } from "@/store/commonStore";
import LoginRemindPopup from "./LoginRemindPopup";

const LoginRemindPopupModal = NiceModal.create(() => {
  const { visible, remove, resolve } = useModal();
  const { isLogin } = useGlobalState();

  const handleClose = useCallback(() => {
    markLoginReminderDismissedForCurrentHomeEntry();
    window.dispatchEvent(new Event(LOGIN_REMINDER_DISMISSED_EVENT));
    resolve();
    remove();
  }, [remove, resolve]);

  useEffect(() => {
    if (visible && isLogin) {
      handleClose();
    }
  }, [handleClose, isLogin, visible]);

  return (
    <PopupMask visible={visible}>
      <LoginRemindPopup onClose={handleClose} />
    </PopupMask>
  );
});

export default LoginRemindPopupModal;
